<ngx-spinner type="ball-atom"></ngx-spinner>
<div class="component-container">
  <div class="component-header">
    <h2>Consultant Firms</h2>
    <div class="button-group">
      <button mat-raised-button color="primary" (click)="onConsultantFirmCorrected()" *ngIf="rightItem && matchedItems && matchedItems.length > 0">
        <mat-icon>assignment_turned_in</mat-icon>
        Correct
      </button>
      <button mat-raised-button color="primary" (click)="toggleSearch()">
        <mat-icon>search</mat-icon>
        @if (isSearchVisible) { Close search } @else { Search @if (getAppliedFiltersCount() > 0) { ({{ getAppliedFiltersCount() }}) } }
      </button>
      <button mat-raised-button color="primary" (click)="onCreateConsultantFirm()">
        <mat-icon>add</mat-icon>
        Add Consultant Firm
      </button>
    </div>
  </div>
  <app-lookup-table-search-box
    [isSearchVisible]="isSearchVisible"
    [showExactMatch]="false"
    (searchFilter)="onSearchFilterChange($event)">
  </app-lookup-table-search-box>
  <app-lookup-table
      [items]="consultantFirms()"
      [columns]="consultantFirmsColumns"
      [enablePaging]="true"
      [enableMatching]="true"
      [serverSidePagination]="true"
      [totalCount]="totalCount"
      [pageSize]="pageSize"
      [pageSizeOptions]="[5, 10, 25, 50]"
      initialSortColumn="name"
      initialSortDirection="asc"
      (itemClick)="onItemSelected($event)"
      (editClick)="onEditConsultantFirm($event)"
      (deleteClick)="onDeleteConsultantFirm($event)"
      (itemSave)="onItemSave($event)"
      (itemAdd)="onItemAdd($event)"
      (pageChange)="onPageChange($event)"
      (sortChange)="onSortChange($event)"
      (readyToMatch)="onReadyToMatch($event)">
    </app-lookup-table>
</div>
